import { NgModule } from "@angular/core";

@NgModule({})
export class LgPivotModule {
    // empty
}
